<template>
  <div class="share-banner">
    <VsButton
      icon="fa:facebook-official"
      @click="share($event, 'shareFB')"
    >
      {{ tI18n.share }}
    </VsButton>

    <VsButton
      icon="fa:twitter"
      @click="share($event, 'shareTW')"
    >
      {{ tI18n.tweet }}
    </VsButton>

    <VsButton
      icon="fa:envelope"
      @click="share($event, 'shareEmail')"
    >
      {{ tI18n.email }}
    </VsButton>
  </div>
</template>

<script>
import VsButton from '@/scripts/Components/Molecules/VsButton';
import socialSharer from '@/scripts/libs/social-sharer';

export default {
  components: {
    VsButton,
  },
  props: {
    tI18n: {
      type: Object,
      default: () => ({
        share: I18n.t('share.actions.share'),
        tweet: I18n.t('share.actions.tweet'),
        email: I18n.t('share.actions.email'),
      }),
    },
    options: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    share(event, payload) {
      if (typeof socialSharer[payload] !== 'function') {
        throw new Error('undefined search method');
      }
      socialSharer[payload](event, this.options);
    },
  },
};
</script>

<style lang="scss" scoped>
.share-banner {
  .vs-button {
    text-transform: capitalize;
  }
}
</style>
